// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "46edd3dc514d8499f88813453551bc4e0dbc0c22/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};